const orange500Color = '#df6f1c';

export default orange500Color;
